import { render, staticRenderFns } from "./QuestionCommentItem.vue?vue&type=template&id=0b0de434&scoped=true&"
import script from "./QuestionCommentItem.vue?vue&type=script&lang=js&"
export * from "./QuestionCommentItem.vue?vue&type=script&lang=js&"
import style0 from "./QuestionCommentItem.vue?vue&type=style&index=0&id=0b0de434&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0de434",
  null
  
)

export default component.exports